import type { InterventionGroupDto } from '../api/generated';
import { PatientLocationType } from '../api/generated';

// A bed is only needed by a patient who stays. A group with no patientType set
// counts as admitted — the template editor's default (templateDraftTypes.ts).
// Shared by the week header's bed chip and the year plan simulation, so a
// simulated plan is judged by the rule the header will show it with.
export const isAdmittedGroup = (group: Pick<InterventionGroupDto, 'patientType'>): boolean =>
  group.patientType !== PatientLocationType.Home;
